<template>
  <article class="more-page">
    <section class="more-page__intro">
      <span>Info</span>
      <h1>Rechtliches und Rahmen.</h1>

      <div class="more-page__links" aria-label="Rechtliche Seiten">
        <a href="/impressum">
          <strong>Impressum</strong>
          <span>Anbieterkennzeichnung und Kontaktangaben.</span>
        </a>
        <a href="/datenschutz">
          <strong>Datenschutz</strong>
          <span>Hinweise zum Websitebetrieb und zu externen Links.</span>
        </a>
      </div>
    </section>
  </article>
</template>

<style scoped>
.more-page {
  min-height: calc(100vh - var(--site-header-height));
  background: var(--color-paper);
  color: var(--color-ink);
}

.more-page__intro {
  min-height: calc(100vh - var(--site-header-height) - 96px);
  margin-right: calc(50% - 50vw);
  margin-left: calc(50% - 50vw);
  padding: 76px max(20px, calc((100vw - 720px) / 2));
  background: var(--color-paper);
}

.more-page__intro > span {
  display: block;
  color: var(--color-muted);
  font-size: 0.78rem;
  font-weight: 900;
  text-transform: uppercase;
}

.more-page h1 {
  margin: 0;
}

.more-page h1 {
  max-width: 620px;
  margin-top: 16px;
  color: var(--color-ink);
  font-size: clamp(3.4rem, 8vw, 5.8rem);
  line-height: 0.94;
  text-wrap: balance;
}

.more-page__links {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  max-width: 540px;
  margin-top: 36px;
}

.more-page__links a {
  display: inline-flex;
  min-height: 118px;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 22px;
  border: 1px solid var(--color-line);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.22);
  color: var(--color-ink-soft);
  text-decoration: none;
  transition: background 180ms ease, border-color 180ms ease,
    transform 180ms ease;
}

.more-page__links strong {
  color: var(--color-ink);
  font-size: 1.02rem;
  font-weight: 900;
  line-height: 1.1;
}

.more-page__links span {
  max-width: 220px;
  color: var(--color-muted);
  font-size: 0.92rem;
  font-weight: 650;
  line-height: 1.35;
  text-align: center;
}

.more-page__links a:hover {
  border-color: rgba(20, 20, 20, 0.18);
  background: rgba(255, 255, 255, 0.42);
  transform: translateY(-1px);
}

@media (max-width: 760px) {
  .more-page__intro {
    min-height: calc(100svh - var(--site-header-height) - 82px);
    padding: 42px 18px;
  }

  .more-page h1 {
    font-size: clamp(2.8rem, 14vw, 4rem);
  }

  .more-page__links {
    grid-template-columns: 1fr;
  }

  .more-page__links a {
    min-height: 96px;
  }
}
</style>
